(() => {
  const mobileQuery = window.matchMedia('(max-width: 749px)');
  const shopifyInboxHints = [
    'shopify-chat',
    'shopifychat',
    'shopifyinbox',
    'inbox.shopify',
    '841fc607-4181-4ad1-842d-e24d7f8bad6b',
    '15683396631634586217'
  ];
  const whatsappHints = ['whatsapp', 'seedgrow', 'wa.me'];
  let scheduled = false;

  function signature(element) {
    if (!element || element.nodeType !== Node.ELEMENT_NODE) return '';

    const attributes = [
      element.tagName,
      element.id,
      element.className,
      element.getAttribute('title'),
      element.getAttribute('aria-label'),
      element.getAttribute('src'),
      element.getAttribute('data-src'),
      element.getAttribute('name'),
      element.getAttribute('data-testid'),
      element.getAttribute('data-block-id')
    ];

    return attributes.filter(Boolean).join(' ').toLowerCase();
  }

  function isWhatsApp(element) {
    const key = signature(element);
    return whatsappHints.some((hint) => key.includes(hint));
  }

  function isShopifyInbox(element, shadowHost) {
    if (!element || isWhatsApp(element) || (shadowHost && isWhatsApp(shadowHost))) return false;

    const key = `${signature(element)} ${shadowHost ? signature(shadowHost) : ''}`;
    if (shopifyInboxHints.some((hint) => key.includes(hint))) return true;

    if (element.tagName === 'IFRAME') {
      const title = (element.getAttribute('title') || '').trim().toLowerCase();
      if ((title === 'chat' || title === 'chat with us') && !isWhatsApp(element)) return true;
    }

    if (shadowHost) {
      const text = (element.textContent || '').trim().toLowerCase();
      if (text === 'chat' || text === 'chat with us') return true;
    }

    return false;
  }

  function hideTarget(element) {
    if (!element || element === document.body || element === document.documentElement) return;

    let target = element;
    let current = element;

    for (let depth = 0; depth < 6 && current.parentElement; depth += 1) {
      const parent = current.parentElement;
      const parentKey = signature(parent);
      const parentStyle = window.getComputedStyle(parent);

      if (
        shopifyInboxHints.some((hint) => parentKey.includes(hint)) ||
        parentStyle.position === 'fixed'
      ) {
        target = parent;
      }

      current = parent;
    }

    if (target === document.body || target === document.documentElement) target = element;

    target.dataset.fjNativeChatHidden = 'true';
    target.style.setProperty('display', 'none', 'important');
    target.style.setProperty('opacity', '0', 'important');
    target.style.setProperty('visibility', 'hidden', 'important');
    target.style.setProperty('pointer-events', 'none', 'important');
  }

  function scanRoot(root, shadowHost = null) {
    if (!root || !root.querySelectorAll) return;

    const elements = Array.from(root.querySelectorAll('*'));
    if (root.nodeType === Node.ELEMENT_NODE) elements.unshift(root);

    elements.forEach((element) => {
      if (isShopifyInbox(element, shadowHost)) {
        hideTarget(shadowHost || element);
      }

      if (element.shadowRoot) {
        scanRoot(element.shadowRoot, element);
      }
    });
  }

  function restoreDesktop() {
    document.querySelectorAll('[data-fj-native-chat-hidden="true"]').forEach((element) => {
      element.style.removeProperty('display');
      element.style.removeProperty('opacity');
      element.style.removeProperty('visibility');
      element.style.removeProperty('pointer-events');
      delete element.dataset.fjNativeChatHidden;
    });
  }

  function scan() {
    scheduled = false;

    if (!mobileQuery.matches) {
      restoreDesktop();
      return;
    }

    scanRoot(document);
  }

  function scheduleScan() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(scan);
  }

  function boot() {
    scheduleScan();

    const observer = new MutationObserver(scheduleScan);
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['id', 'class', 'title', 'aria-label', 'src', 'style']
    });

    window.setTimeout(scheduleScan, 500);
    window.setTimeout(scheduleScan, 1500);
    window.setTimeout(scheduleScan, 3500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  if (typeof mobileQuery.addEventListener === 'function') {
    mobileQuery.addEventListener('change', scheduleScan);
  } else if (typeof mobileQuery.addListener === 'function') {
    mobileQuery.addListener(scheduleScan);
  }
})();
